<template>
    <div class="flex flex-col items-center gap-8 w-full max-w-3xl">
        <div class="text-center leading-tight">
            <div class="max-w-2xl display-medium text-balance mb-4">Day 1 vs Day 60</div>
            <p class="text-valence-grey-750 body md:display-serif max-w-xl mx-auto text-pretty">On day one, you come to Nadia. On day sixty, Nadia comes to you.</p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <!-- Day 1 Card -->
            <div class="flex flex-col gap-4 rounded-2xl border-2 border-gray-200 bg-white p-6 min-h-[280px]">
                <div class="flex items-center gap-3">
                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100">
                        <span class="text-sm font-bold text-gray-500">1</span>
                    </div>
                    <h3 class="title-body text-gray-500">Day 1</h3>
                </div>

                <div class="flex-1 flex flex-col items-center justify-center text-center gap-3 py-4">
                    <div class="text-3xl text-gray-300"><i class="bi bi-chat-dots" aria-hidden="true"></i></div>
                    <p class="body text-gray-600 italic">"I have a tough 1:1 with my manager tomorrow. Can you help me prepare?"</p>
                </div>
            </div>

            <!-- Day 60 Card -->
            <div class="flex flex-col gap-4 rounded-2xl border-2 border-indigo-200 bg-white p-6 min-h-[280px] ring-1 ring-indigo-100">
                <div class="flex items-center gap-3">
                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-100">
                        <span class="text-sm font-bold text-indigo-600">60</span>
                    </div>
                    <h3 class="title-body text-indigo-700">Day 60</h3>
                </div>

                <div class="flex-1 flex flex-col items-center justify-center text-center gap-3 py-4">
                    <div class="text-3xl text-indigo-400"><i class="bi bi-stars" aria-hidden="true"></i></div>
                    <p class="body text-indigo-700 italic">
                        "I noticed your 1:1 with Jordan is tomorrow — last time you mentioned tension around the Q3 roadmap. Want to prepare?"
                    </p>
                    <div class="flex flex-wrap justify-center gap-2 mt-2">
                        <span
                            class="inline-flex items-center gap-1 rounded-full bg-valence-pink-50 px-3 py-1 text-xs font-medium text-valence-pink-800 ring-1 ring-valence-pink-200">
                            <span class="h-1.5 w-1.5 rounded-full bg-valence-pink-400"></span>
                            Working style
                        </span>
                        <span
                            class="inline-flex items-center gap-1 rounded-full bg-valence-light-blue-50 px-3 py-1 text-xs font-medium text-valence-light-blue-800 ring-1 ring-valence-light-blue-200">
                            <span class="h-1.5 w-1.5 rounded-full bg-valence-light-blue-400"></span>
                            Jordan's profile
                        </span>
                        <span
                            class="inline-flex items-center gap-1 rounded-full bg-valence-violet-50 px-3 py-1 text-xs font-medium text-valence-violet-800 ring-1 ring-valence-violet-200">
                            <span class="h-1.5 w-1.5 rounded-full bg-valence-violet-400"></span>
                            Calendar
                        </span>
                        <span class="inline-flex items-center gap-1 rounded-full bg-[#fef5e1] px-3 py-1 text-xs font-medium text-valence-gold-800 ring-1 ring-[#f9d43f]">
                            <span class="h-1.5 w-1.5 rounded-full bg-valence-gold-600"></span>
                            Past sessions
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center gap-4 mt-2">
            <BaseButton theme="tertiary" @click="emit('back')"> <i class="bi bi-arrow-left mr-1" aria-hidden="true"></i> Back </BaseButton>
            <BaseButton theme="primary" class="w-60 leading-6 body-small" @click="emit('next')"> Continue </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

const emit = defineEmits<{
    next: [];
    back: [];
}>();
</script>
